import { Component, OnInit, Sanitizer } from '@angular/core';
import { ProviderService } from 'src/app/services/provider.service';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { PromiseResult, ServerError } from 'src/app/models/PromiseResult';
import { ProviderStateService } from 'src/app/services/provider-state.service';


@Component({
  selector: 'app-provider-agreement',
  templateUrl: './provider-agreement.component.html',
  styleUrls: ['./provider-agreement.component.css', '../../../../../assets/css/custom-egd.css']
})
export class ProviderAgreementComponent implements OnInit {
  document_body: SafeHtml;
  response: PromiseResult = new PromiseResult();
  slug: string = "";
  serverError = new ServerError();
  constructor(private readonly providerService: ProviderService,
    private readonly sanitizer: DomSanitizer,
    private readonly providerStateService: ProviderStateService
  ) { }

  ngOnInit(): void {
    this.fetchAgreement();
    this.slug = this.providerStateService.getProviderSlug();
  }


  async fetchAgreement(): Promise<void> {

    await this.providerService.getProviderAgreement()
      .toPromise()
      .then(result => {
        this.response = result;
        if (result.success) {
          this.document_body = this.sanitizer.bypassSecurityTrustHtml(result.data.agreementHtml);

        }

      })
      .catch((error) => {
        this.serverError = error.error;
        this.response.success = false;

      })

  }
}
